import React, {useEffect, useState} from 'react';
import {Button, Form, Input, Modal, Row, Col} from 'antd';
import {CommandDto} from '../../../api';
import {EditOutlined, RightOutlined} from "@ant-design/icons";
import {getLabelWithNameAndInfotext} from "../../../utils/Utils";
import DescriptionFormItem from "../../form/DescriptionFormItem";


const NavigateCommandModal = ({onCommandCardData, initialData}: { onCommandCardData: Function; initialData?: CommandDto }) => {
    const [form] = Form.useForm();
    const [isModalVisible, setIsModalVisible] = useState(false); // State für die Modal-Sichtbarkeit

    useEffect(() => {
        // Wenn initialData vorhanden ist, fülle das Formular mit den initialen Daten
        if (initialData) {
            form.setFieldsValue({
                targetUrl: initialData.navigateUrl,
                systemTab: initialData.systemTab,
                description: initialData.description
            });
        }
    }, [initialData, form]);

    const onFinish = (values) => {
        let command: CommandDto = {navigateUrl: values.targetUrl, systemTab: values.systemTab, commandType: 'NAVIGATE',
            description: values.description};
        onCommandCardData(command);
        setIsModalVisible(false); // Modal schließen
    };

    const onReset = () => {
        form.resetFields();
    };

    // Funktion zum Öffnen des Modals
    const showModal = () => {
        setIsModalVisible(true);
    };

    // Funktion zum Schließen des Modals
    const handleCancel = () => {
        setIsModalVisible(false);
    };

    return (
        <>
            {initialData == null &&
                <div style={{display: 'flex', alignItems: 'stretch', justifyContent: 'stretch'}}>
                  <Button
                      type="primary"
                      onClick={showModal}
                      style={{width: '100%', height: '100%'}}
                  >
                    <RightOutlined />Navigieren
                  </Button>
                </div>}
            {initialData != null &&
                <Button
                    type="primary"
                    style={{float: 'right'}}
                    onClick={showModal}
                >
                  <EditOutlined/>
                </Button>
            }
            <Modal
                title="Navigation"
                open={isModalVisible}
                onCancel={handleCancel}
                footer={null}
            >
                <Form
                    form={form}
                    name="control-hooks"
                    onFinish={onFinish}
                    style={{maxWidth: 600}}
                    layout="vertical"
                >
                    <Form.Item name="targetUrl" label="Ziel-Adresse" rules={[{required: true, message: 'Bitte gebe eine Ziel-Adresse ein'}]}>
                        <Input/>
                    </Form.Item>
                    <Form.Item name="systemTab"
                               label={getLabelWithNameAndInfotext("Browser-Tab",
                                   "Neuer Name: Neuer Browsertab", "Bekannter Name: Wechsel zu bestehendem Browsertab")}
                               rules={[{required: true, message: 'Bitte gebe einen Browser-Tab ein'}]}>
                        <Input/>
                    </Form.Item>
                    <DescriptionFormItem />
                    <Form.Item>
                        <Row justify="center">
                            <Col style={{marginRight: 5}}>
                                <Button type="primary" htmlType="submit" >
                                    {initialData ? "Speichern" : "Hinzufügen"}
                                </Button>
                            </Col>
                            <Col>
                                <Button htmlType="button" onClick={onReset}>
                                    Zurücksetzen
                                </Button>
                            </Col>
                        </Row>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default NavigateCommandModal;
